import { Component, ViewChild } from '@angular/core';
import { BehaviorSubject, debounceTime, firstValueFrom } from 'rxjs';
import { ErrorHandlerService } from '../../../../shared/services/error-handler.service';
import { MasterService } from '../../../../shared/services/master.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { CarrierModel } from '../../models/carriers.model';
import { CarriersApiService } from '../../services/carriers-api.service';
import { AddEditCarrierComponent } from '../add-edit-carrier/add-edit-carrier.component';

@Component({
  selector: 'app-carriers-listing',
  standalone: false,
  templateUrl: './carriers-listing.component.html',
  styleUrl: './carriers-listing.component.css',
})
export class CarriersListingComponent {
  @ViewChild('addEditComponent') addEditComponent!: AddEditCarrierComponent;

  userInfo: any;
  companyId: number = 0;
  carriers: CarrierModel[] = [];
  carrierObj: CarrierModel = new CarrierModel();
  loading: boolean = false;
  search: string = '';
  searchSubject = new BehaviorSubject<string>('');

  constructor(
    private carriersApiService: CarriersApiService,
    private toastService: ToasterService,
    private masterService: MasterService,
    private errorHandlerService: ErrorHandlerService,
  ) {}

  ngOnInit(): void {
    this.userInfo = this.masterService.getUserDetailFromStorage();
    this.companyId = Number(this.userInfo.companyId);

    this.searchSubject.pipe(debounceTime(450)).subscribe((search) => {
      this.loadCarriers(search);
    });
  }

  loadCarriers(searchTerm: string): void {
    this.loading = true;
    const queryParams: Record<string, any> = {
      CompanyId: this.companyId,
      ...(searchTerm?.trim() ? { SearchTerm: searchTerm } : {}),
    };

    firstValueFrom(this.carriersApiService.getCarriers(queryParams))
      .then((response) => {
        this.carriers = Array.isArray(response) ? response : [response];
      })
      .catch((error) => {
        this.errorHandlerService.handleApiError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  handleSearch(searchTerm: string): void {
    this.searchSubject.next(searchTerm);
  }

  handleTriggerFromChild(): void {
    this.loadCarriers('');
  }

  openAddEditForm(id: number): void {
    this.addEditComponent.initializeRecord(id);
  }

  selectRecordToDelete(carrier: CarrierModel): void {
    this.carrierObj = carrier;
  }

  deleteRecord(): void {
    const id = this.carrierObj.id;

    this.carriersApiService.deleteCarrier(id).subscribe({
      next: () => {
        this.loadCarriers('');
        this.toastService.success('Carrier has been deleted successfully!');
      },
      error: (err) => {
        this.errorHandlerService.handleApiError(err);
      },
    });
  }

  handleDeleteClick(carrier: CarrierModel): void {
    // Add any conditional logic here if needed (e.g., carrier in use)
    this.selectRecordToDelete(carrier);
  }
}
